export class EmailServiceModel {
    From: string;
    To: string;
    Subject: string;
    Body: string;
    AttachmentPath: string;
    isHtml?: boolean;

    constructor(
        From: string,
        To: string,
        Subject: string,
        Body: string,
        AttachmentPath: string,
        isHtml?: boolean
    ) {
        this.From = From;
        this.To = To;
        this.Subject = Subject;
        this.Body = Body;
        this.AttachmentPath = AttachmentPath;
        this.isHtml = isHtml;
    }
}